<template>
  <BlockFieldset class="project-iab-tax-data">
    <b-row>
      <b-col lg="6" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('taxTable')"
          label-for="taxTable"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            id="taxTable"
            v-model="project.investmentDeductionAllowance.taxTable"
            :disabled="isBlockReadOnly"
            type="text"
            :placeholder="$t('taxTable')"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('effectiveTaxRatePercent')"
          label-for="effectiveTaxRatePercent"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="effectiveTaxRatePercent"
            v-model="project.investmentDeductionAllowance.effectiveTaxRatePercent"
            :disabled="isBlockReadOnly"
            unit="unit_percent"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('churchTaxRatePercent')"
          label-for="churchTaxRatePercent"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <Dropdown
            id="churchTaxRatePercent"
            v-model="project.investmentDeductionAllowance.churchTaxRatePercent"
            :disabled="isBlockReadOnly"
            :options="churchTaxRateOptions"
            optionLabel="label"
            optionValue="value"
            :placeholder="$t('unit_percent')"
            :showClear="true"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('taxRatePercent')"
          label-for="taxRatePercent"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="taxRatePercent"
            v-model="project.investmentDeductionAllowance.taxRatePercent"
            :disabled="isBlockReadOnly"
            unit="unit_percent"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('taxableIncomeEur')"
          label-for="taxableIncomeEur"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="taxableIncomeEur"
            v-model="project.investmentDeductionAllowance.taxableIncomeEur"
            :disabled="isBlockReadOnly"
            unit="unit_eur"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('iabPercent')"
          label-for="iabPercent"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="iabPercent"
            v-model="project.investmentDeductionAllowance.iabPercent"
            :disabled="isBlockReadOnly"
            unit="unit_percent"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <div v-if="hasSaveButton" class="text-right mt-2">
      <b-button variant="bg" :disabled="isSaving" @click="save">
        {{ $t('saveNamed', { name: $t('project_iab_tax_data') }) }}
      </b-button>
    </div>
  </BlockFieldset>
</template>

<script>
import { mapActions } from 'vuex';
import UnitInputNumber from '@/components/UnitInputNumber';
import Dropdown from 'primevue/dropdown';
import BlockFieldset from '@/components/Access/BlockFieldset.vue';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import { BlockSaveMixin } from '@/mixins/blockSave';
import { toProjectIabTaxDataInput } from './projectIabTaxDataInput';

/** Number of the unsaved project (ProjectEdit `_new`): its values go with `createProject`. */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Block project-iab-tax-data ("IAB- und Steuerdaten", plan
 * docs/work/_done/2026-10-project-block-iab-tax-data): the tax fields of `investmentDeductionAllowance`,
 * saved through its own mutation with its own button. On the unsaved project it has no save
 * button. Emits `dirty` and `saved`.
 */
export default {
  name: 'ProjectIabTaxData',
  components: {
    BlockFieldset,
    Dropdown,
    UnitInputNumber,
  },
  mixins: [AccessBlockMixin, BlockSaveMixin],
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
  },
  data() {
    return {
      churchTaxRateOptions: [
        { value: 0, label: '0 %' },
        { value: 8, label: '8 %' },
        { value: 9, label: '9 %' },
      ],
    };
  },
  computed: {
    blockInput() {
      return toProjectIabTaxDataInput(this.project);
    },
    hasSaveButton() {
      return !this.isBlockReadOnly && this.project.number !== NEW_PROJECT_NUMBER;
    },
  },
  methods: {
    ...mapActions(['updateProjectIabTaxData']),
    saveBlockInput(input) {
      return this.updateProjectIabTaxData({ projectNumber: this.project.number, input });
    },
  },
};
</script>
